import { render, staticRenderFns } from "./SellerSalesRecordTable.vue?vue&type=template&id=4731e174&"
import script from "./SellerSalesRecordTable.vue?vue&type=script&lang=js&"
export * from "./SellerSalesRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports